import React from 'react';

import { Project } from '@interfaces/projects';
import { Category, CompanyData } from '@interfaces/ti50';
import { parameterize } from '@utils/formatting';

import CSVDownloadLink from '../CSVDownloadLink';
import CategorySection from './CategorySection';
import Glossary from './Glossary';

interface MainContentProps {
  activeCategories: Category[];
  data: CompanyData;
  isCurrentUserCorpOrGroupSubscriber: boolean;
  project: Project;
  TI50Year: number;
}

const MainContent = ({
  activeCategories,
  data,
  isCurrentUserCorpOrGroupSubscriber,
  project,
  TI50Year,
}: MainContentProps) => {
  return (
    <>
      <div className="col-xs-12">
        <span id="no-paywall"></span>
        {activeCategories.map(({ authors, category, description, image_name }) => (
          <CategorySection
            key={parameterize(category)}
            authors={authors}
            category={category}
            categoryImageName={image_name}
            data={data}
            description={description}
            projectSlug={project.slug}
            TI50Year={TI50Year}
          />
        ))}
      </div>
      <div className="container">
        <Glossary />
        {isCurrentUserCorpOrGroupSubscriber && (
          <div className="row">
            <CSVDownloadLink id={project.id} slug={project.slug} sheetName={`${TI50Year}`} />
          </div>
        )}
      </div>
    </>
  );
};

export default MainContent;
